import { Injectable } from '@angular/core';
import { DocumentService } from './document.service';
import { VendorDocumentCategory } from './vendor.service';
import * as Parse from 'parse';
import { AuthService } from './auth.service';

@Injectable()
export class VendorDocumentService {

    constructor(
        private documentService: DocumentService,
        private auth: AuthService
    ) {}

    loadDocumentsByCategory(vendor: Parse.Object, category: VendorDocumentCategory) {
        const query: Parse.Query = new Parse.Query('VendorDocument');
        query.equalTo('vendor', vendor);
        query.equalTo('category', category);
        query.descending('createdAt');

        return query.find();
    }

    async createDocument(file: File, vendor: Parse.Object, category: VendorDocumentCategory, ) {

        const fileName: string = file.name.replace(/.*\./gi, category + '_' + Math.random().toString(16).replace('.', '_') + '.');
        const parseFile: Parse.File = new Parse.File(fileName, file);

        const document: Parse.Object = new Parse.Object('VendorDocument');
        document.set('file', parseFile);
        document.set('name', file.name);
        document.set('vendor', vendor);
        document.set('category', category);
        document.set('uploadedBy', this.auth.currentUser);

        try {
            // Generate thumbnail
            if (file.type === 'application/pdf') {
                const thubmnailBase64 = await this.documentService.generatePDFThumbnail(file);

                if (thubmnailBase64) {
                    const thumbnail: Parse.File = new Parse.File('thumb.png', { base64: thubmnailBase64 });
                    document.set('thumbnail', thumbnail);
                }
            } else {
                document.set('thumbnail', null);
            }
        } catch (error) {
            console.error(error);
            // Thumbnail creation can fail silently
        }

        // const acl: Parse.ACL = new Parse.ACL();
        //
        // acl.setRoleReadAccess('Admin', true);
        // acl.setRoleWriteAccess('Admin', true);
        // acl.setRoleReadAccess('SA', true);
        // acl.setRoleReadAccess('AA', true);
        // acl.setRoleReadAccess('AAA', true);
        // acl.setRoleReadAccess('TC', true);
        // acl.setRoleReadAccess('View-Only-Admin', true);
        //
        // document.setACL(acl);


        return document.save();
    }
}
